import {Workflow} from './Workflow';
import {EntitySerializer} from '@edward-software/edw-fwk-angular-lib/models';


export class WorkflowSerializer implements EntitySerializer {

    public mapping = new Map([
        ['id', 'id'],
        ['name', 'name'],
        ['description', 'description'],
        ['type', 'type'],
        ['validationUrl', 'validation_url'],
        ['workflowId', 'workflow_id'],
        ['workflowName', 'workflow_name'],
        ['workflowDescription', 'workflow_description'],
        ['api', 'api'],
        ['apiType', 'api_type']
    ]);

    fromJson(json: any): Workflow {
        const workflow = new Workflow();
        this.mapping.forEach((value, key, map) => {
            workflow[key] = json[value];
        });

        if (workflow.workflowId) {
            workflow.id = workflow.workflowId;
        }
        if (workflow.workflowName) {
            workflow.name = workflow.workflowName;
        }
        if (workflow.workflowDescription) {
            workflow.description = workflow.workflowDescription;
        }

        return workflow;
    }

    toApi(workflow: Workflow): any {
        const obj = {};
        this.mapping.forEach((value, key, map) => {
            obj[value] = workflow[key];
        });
        return obj;
    }
}
